/*  ========================================================== 
		BANNER WITH GRAB / CREDIT PROMO CODES 
 ==========================================================*/
function copyToClipboard(code, cb) {
  var input = document.createElement("input");
  input.setAttribute("value", code);
  input.setAttribute("readonly", "");
  input.style.position = "absolute";
  input.style.left = "-9999px";
  document.body.appendChild(input);
  input.select();
  //for mobile devices this is mandatory
  input.setSelectionRange(0, 99999);
  document.execCommand("copy");
  document.body.removeChild(input);
  cb();
}
function addCodeClick() {
  jQuery(document).on("click", ".v_codeRow", function () {
    if (!jQuery(this).hasClass("codeClicked")) {
      var THIS = jQuery(this);
      var code = jQuery(this).attr("data-code");
      $(this).addClass("codeClicked");
      copyToClipboard(code, function () {
        jQuery(".v_copiedMsg").hide();
        THIS.find(".v_copiedMsg").slideDown("fast").css("display", "flex");
        var d = setTimeout(function () {
          THIS.find(".v_copiedMsg").slideUp("fast");
          THIS.removeClass("codeClicked");
        }, 5000);
      });
    }
  });
}
function togglePopup() {
  jQuery(".pp_popup_promo").appendTo(".main-content");
  jQuery("body").toggleClass("pp_popup_promo_active");
  addCodeClick();
}
jQuery(".pp_popup_promo .hidden-close").on("click", function () {
  jQuery("body").toggleClass("pp_popup_promo_active");
});

/* ==========================================================
			COLLECTION BANNER DESCRIPTION / BANNER LINE
============================================================= */

jQuery(document).on("click", ".read-desc", function (e) {
  jQuery(".banner-line.collection-description").addClass("active");
  jQuery(".read-desc").addClass("active");
});
jQuery(document).on("click", ".read-desc.active", function (e) {
  jQuery(".banner-line.collection-description").removeClass("active");
  jQuery(".read-desc").removeClass("active");
});
/*


*/
if (jQuery(window).width() < 1023) {
  jQuery(document).on("click", ".stock-wrap-nov .learnmore", function (e) {
    jQuery(".stockclose").addClass("show");
    jQuery(".stock-wrap-nov .popover").addClass("show");
  });

  jQuery(document).on("click", ".stockclose", function (e) {
    jQuery(".stock-wrap-nov .popover").removeClass("show");
    jQuery(".stockclose").removeClass("show");
  });
} else {
  jQuery(".stock-wrap-nov .learnmore").hover(
    function () {
      jQuery(".stock-wrap-nov .popover").addClass("show");
    },
    function () {
      jQuery(".stock-wrap-nov .popover").removeClass("show");
    }
  );
}
/* ====================================================
				NAV MENU ON MOBiLE
=======================================================*/
window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1000 / 60);
  };
window["prismCategoryBar4033V1"] = function () {
  if (
    typeof jQuery !== typeof undefined &&
    jQuery(
      "#shopify-section-header .header-wrap .mobile-nav-wrapper .mobile-nav"
    ).length &&
    !jQuery(".prismCategoryBar4033V1").length
  ) {
    jQuery("body").addClass("prismCategoryBar4033V1");
    addSubCategoryStrip4033V1();
  } else {
    window.requestAnimationFrame(prismCategoryBar4033V1);
  }
};
window.prismCategoryBar4033V1();
function addSubCategoryStrip4033V1() {
  if (!jQuery(".vwoCategoryBar").length) {
    // jQuery("#shopify-section-header header.site-header").after(htm);
  }
}
/* =============================================
  		COLLECTION PAGE VARIANT SELECT // VARIANT COLOR HEIGHT ADJUSTMENT
================================================ */
jQuery(document).ready(function ($) {
  if ($(".colorlist li").hasClass("variant-item")) {
    //console.log('list has color variants');
    $(".colorlist").addClass("active");
  }
});
/* variant select // collection page */
jQuery(document).ready(function () {
  $(".variant-color").on("click", function () {

  var $card = $(this).closest(".grid-view-item");

  // -------------------
  // GET DATA
  // -------------------
  var produrl = $(this).attr("data-url");
  var prodid = $(this).attr("data-id");
  var button = $(this).attr("data-button");
  var price = $(this).attr("data-price");
  var compare = $(this).attr("data-compare");
  let ptype  = $(this).attr("data-title");
    console.log('varprice:'+prodid);
    console.log('varprice:'+price);
    console.log('ptype:'+ptype);
  // -------------------
  // IMAGE LOGIC (UNCHANGED BUT SCOPED)
  // -------------------
  var size = $card.find(".collection.variant li .variant-color.selected")
                  .closest("li")
                  .attr("data-ptype") || "";

  var color = $card.find(".collection.colorlist li .variant-color.selected")
                  .closest("li")
                  .attr("data-color") || "";

  var color2 = $(this).attr("data-image") || "";

  var imgurl = "";

  if (size && color) {
    var key = size + "-" + color;
    imgurl = $card.find(".param-list li." + key).attr("data-image") || "";
  }

  if (!imgurl && color2) {
    imgurl = color2;
  }

  if (imgurl) {
    $card.find(".grid-view-item__image").attr("src", imgurl);
  }

  // -------------------
  // UPDATE LINK
  // -------------------
  $card.find(".grid-view-item__link").attr("href", produrl);

  // -------------------
  // UPDATE CART LINK
  // -------------------
  $card.find(".grid-view-item__link")
    .attr("href", produrl + "&ptype=" + (ptype || ""));

  // -------------------
  // UPDATE PRICE (FIXED)
  // -------------------
  $card
    .find(".new-collection-price-wrapper")
    .find(".price, .price-item, .price-wrapper")
    .first()
    .text(price);

  // -------------------
  // UPDATE COMPARE PRICE
  // -------------------
  $card
    .find(".new-collection-price-wrapper .product-compare")
    .text(compare);

  // -------------------
  // UPDATE BUTTON
  // -------------------
  if (button != "") {
    $card
      .find(".new-collection-price-wrapper .grid_shop")
      .html('<a href="' + produrl + '">' + button + "</a>");
  } else {
    $card
      .find(".new-collection-price-wrapper .grid_shop")
      .html('<a href="' + produrl + '">Shop Now</a>');
  }

  // -------------------
  // SELECT STATE
  // -------------------
  $(this)
    .closest("li")
    .siblings()
    .find(".variant-color")
    .removeClass("selected");

  $(this).addClass("selected");

});

  /* for with parameters, color and type selector on collection pages like laundry 
    on click, add color and type parameters to url.. in product scripts, it is found under getUrlParameters function
    key identifier is the "with-params" class
    */
 $(".with-params .variant-item").on("click", function () {
  console.log('with params click');
  // SCOPE: operate only inside this product card
  const $card = $(this).closest(".grid-view-item");

  // Base product link
  const curLink = $(this).find("span.variant-color").data("url") || "";

  // Try extracting clicked attributes
  let pcolor = $(this).attr("data-color");
  let ptype  = $(this).attr("data-ptype");
  console.log('ptype:'+ptype);

  // If pcolor not provided → get active color from sibling selector
  if (!pcolor) {
    pcolor = $card.find(".main-color .variant-color.selected").parent().attr("data-color") || "";
  }

  // If ptype not provided → get active type from sibling selector
  if (!ptype) {
    ptype = $card.find(".main-type .variant-color.selected").attr("data-title") || "";
  }

  // Build lookup key (for price & image)
  const paramProd = [ptype, pcolor].filter(Boolean).join("-");
  console.log("collection select:", paramProd);

  // Pull price and compare-at price from hidden param list
  const $paramItem = $card.find(".param-list ." + paramProd);
  const paramPrice = $paramItem.attr("data-price") || "";
  const paramCompare = $paramItem.attr("data-compare") || "";
  console.log('my new price:'+paramPrice);
  console.log(paramCompare);
  // Update price
  $card.find(".product-price__price .price-wrapper").text(paramPrice);
  $card.find(".product-compare").text("$" + paramCompare);

  // Get image from hidden param list (size + color combo)
  const imgurl_param = $paramItem.attr("data-image") || "";

  // Fallback to selected color image
  const imgurl_color = $card
    .find(".main-color .variant-color.selected")
    .attr("data-image") || "";

  // Decide final image
  const imgurl = imgurl_param || imgurl_color;

  console.log(imgurl);

  if (imgurl) {
    $card.find(".grid-view-item__image").attr("src", imgurl);
  }
  if (imgurl) {
    $card.find(".grid-view-item__image").attr("src", imgurl);
  }

  // Build final product URL — ALWAYS include both params
  const produrl = 
      curLink +
      "&pcolor=" + (pcolor || "") +
      "&ptype="  + (ptype  || "");

  // Update links for THIS card only
  $card.find(".grid_shop a").attr("href", produrl);
  $card.find(".grid-view-item__link").attr("href", produrl);

  // Update short description (small text under title)
  const ptype_title =
    $card.find(".main-type .variant-color.selected").text().trim() ||
    $(this).find(".variant-color").text().trim() ||
    "";

  $card.find(".pro_grid_desc span.to-change").text(ptype_title);

  
});
//fallback for those without color
  $(document).on("click", ".main-type-fix .variant-color", function () {
  var $card = $(this).closest(".grid-view-item");
  var title = $(this).text().trim();

  $card.find(".to-change").text(title);
});

/* end of line */
});
